/**
 * Implementation of IFloodgateTelemetryLogger for Web SDK
 */

import * as Api from "@ms-ofb/officefloodgatecore/dist/src/Api/Api";
import * as Logging from "../Logging/Logging";

export default class IFloodgateTelemetryLogger implements Api.IFloodgateTelemetryLogger {
	private readonly SAMPLING_PERCENTAGE = 1;  // percentage of data should be logged
	private readonly SAMPLING_RANGE = 100;
	private readonly SAMPLING_RESULT = Math.floor(Math.random() * this.SAMPLING_RANGE);

	/**
	 * Log that a survey's trigger was met.
	 * @param campaignId Id of the campaign the survey belongs to.
	 * @param surveyId Id of the survey.
	 * @param surveyType Type of the survey.
	 */
	public log_TriggerMet(campaignId: string, surveyId: string, surveyType: Api.ISurvey.Type): void {
		Logging.getLogger().logEvent(Logging.EventIds.Survey.Floodgate.TriggerMet.VALUE,
			Logging.LogLevel.Critical,
			{
				CampaignId: campaignId,
				SurveyId: surveyId,
				SurveyType: surveyType,
			});
	}

	/**
	 * Log that a user was selected(nominated) for a survey if it's not sampled
	 * @param campaignId Id of the campaign the survey belongs to.
	 * @param surveyId Id of the survey.
	 * @param surveyType Type of the survey.
	 */
	public log_UserSelected(campaignId: string, surveyId: string, surveyType: Api.ISurvey.Type): void {
		if (this.isLoggingSignalUnsampled()) {
			Logging.getLogger().logEvent(Logging.EventIds.Survey.Floodgate.UserSelected.VALUE,
				Logging.LogLevel.Critical,
				{
					CampaignId: campaignId,
					SurveyId: surveyId,
					SurveyType: surveyType,
				});
		}
	}

	/**
	 * Log that campaign definitions failed to load.
	 * @param errorMessage error message
	 */
	public log_CampaignLoad_Failed(errorMessage: string): void {
		Logging.getLogger().logEvent(Logging.EventIds.Survey.Floodgate.CampaignLoad.Failed.VALUE,
			Logging.LogLevel.Error,
			{
				ErrorMessage: errorMessage,
			});
	}

	/**
	 * Log an event with properties
	 * @param eventId event id
	 * @param properties telemetry event properties
	 */
	public log_Event(eventId: string, properties: Api.ITelemetryProperties): void {
		const event: Logging.IEventId = { name: eventId };
		Logging.getLogger().logEvent(event, Logging.LogLevel.Critical, properties);
	}

	private isLoggingSignalUnsampled(): boolean {
		return this.SAMPLING_RESULT < this.SAMPLING_PERCENTAGE;
	}
}
